import Vue from "vue";
import VueFbCustomerChat from 'vue-fb-customer-chat';

Vue.use(VueFbCustomerChat, {
    page_id: '115553340359824', //  change 'null' to your Facebook Page ID,
    theme_color: '#472F92', // theme color in HEX
    locale: 'en_US', // default 'en_US'
})